import { motion } from "framer-motion";
import { Home, Building2, ArrowRight } from "lucide-react";

const IMG = {
  particuliers:
    "https://images.unsplash.com/photo-1598928506311-c55ded91a20c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxicmlnaHQlMjBjbGVhbiUyMGFyY2hpdGVjdHVyYWwlMjBpbnRlcmlvciUyMGxpdmluZyUyMHJvb218ZW58MHx8fHwxNzkzMTg2MjM4fDA&ixlib=rb-4.1.0&q=80&w=1200",
  professionnels:
    "https://images.pexels.com/photos/245219/pexels-photo-245219.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

const BLOCKS = [
  {
    id: "particuliers",
    testid: "audience-card-particuliers",
    ctaTestid: "audience-cta-particuliers",
    icon: Home,
    title: "Particuliers",
    desc: "Ménage de logements, nettoyage de vitres et remise en état : DIMORA s'occupe de votre intérieur avec le même soin que vous.",
    cta: "Découvrir l'espace particuliers",
    img: IMG.particuliers,
  },
  {
    id: "professionnels",
    testid: "audience-card-professionnels",
    ctaTestid: "audience-cta-professionnels",
    icon: Building2,
    title: "Professionnels",
    desc: "Entretien de bureaux et de locaux, interventions régulières ou ponctuelles, vitres et nettoyage de fin de chantier pour les entreprises et commerces.",
    cta: "Découvrir l'espace professionnels",
    img: IMG.professionnels,
  },
];

export const Audiences = () => (
  <section data-testid="audiences-section" className="py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="mb-14 text-center"
      >
        <p className="text-xs uppercase tracking-[0.25em] text-amber-400 font-semibold mb-4">À qui s'adresse DIMORA ?</p>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white">
          Deux clientèles, <span className="text-amber-300">une même exigence</span>
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {BLOCKS.map((b, i) => (
          <motion.a
            key={b.id}
            href={`#${b.id}`}
            data-testid={b.testid}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.65, delay: i * 0.12 }}
            whileHover={{ y: -6, transition: { duration: 0.3 } }}
            className="group relative overflow-hidden rounded-3xl border border-white/10 min-h-[320px] flex flex-col justify-end p-8 sm:p-10 transition-colors duration-500 hover:border-amber-400/40"
          >
            <img
              src={b.img}
              alt={b.title}
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover opacity-30 transition-all duration-700 group-hover:opacity-45 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0D14] via-[#0A0D14]/70 to-transparent" />
            <div className="relative">
              <span className="inline-flex items-center justify-center w-12 h-12 rounded-2xl bg-amber-400/10 border border-amber-400/25 text-amber-300 mb-5">
                <b.icon className="w-6 h-6" strokeWidth={1.5} />
              </span>
              <h3 className="font-display text-2xl sm:text-3xl font-bold text-white tracking-tight">{b.title}</h3>
              <p className="mt-3 text-sm text-slate-300 leading-relaxed max-w-md">{b.desc}</p>
              <span
                data-testid={b.ctaTestid}
                className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-amber-300 transition-colors duration-300 group-hover:text-amber-200"
              >
                {b.cta}
                <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
              </span>
            </div>
          </motion.a>
        ))}
      </div>
    </div>
  </section>
);
